
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import GeoPoint = firebase.firestore.GeoPoint;
import { Snackbar } from 'buefy/dist/components/snackbar';

/* tslint:disable:no-console */

// You can declare a mixin as the same style as components.
@Component
export default class CurrentLocation extends Vue {
    public currentLocation: Position | null;
    constructor() {
        super();
        this.currentLocation = null;
    }

    public created() {
        if (navigator.geolocation) {
            const options = { timeout: 60000 }; // 60 seconds
            navigator.geolocation.getCurrentPosition(this.setCurrentLocation, this.errorHandler, options);
        } else {
            console.log('Geolocation is not supported by this browser');
        }
    }

    public convertMyLocToGeoPoint(): GeoPoint | null {
        if (this.currentLocation) {
            return new GeoPoint(this.currentLocation.coords.latitude, this.currentLocation.coords.longitude);
        }
        return null;
    }

    public setCurrentLocation(position: Position) {
        this.currentLocation = position;
    }

    public errorHandler(err: any) {
        if (err.code === 1) { // Access Denied
            this.$snackbar.open({
                message: 'We were not able to access your location information which means' +
                ' you may experience issues finding friends on our map.' +
                'Please tell your browser you would like to provide your location to MAF.' +
                ' This will not be displayed to other users and is only used for showing your nearby friends.',
                    type: 'is-danger',
                    indefinite: true,
                    position: 'is-top',
                });
        } else if (err.code === 2) { // Position Unavailable
            this.$snackbar.open({
                message: 'Error: Position is unavailable.' +
                ' This might affect your ability to see users',
                type: 'is-danger',
                indefinite: true,
                position: 'is-top',
            });
        } else if (err.conde === 3) { // Location request Timed out
            this.$snackbar.open({
                message: 'Error:The request to get user location has timed out as it has taken too long.',
                type: 'is-danger',
                indefinite: true,
                position: 'is-top',
            });
        } else { // Other reasons
            this.$snackbar.open({
                message: 'Error: Unknown Error with GeoLocation.',
                type: 'is-danger',
                indefinite: true,
                position: 'is-top',
            });
        }
    }
}
